<template>
    <div class="animated fadeIn">
      <div class="row mb-20">
        <div class="col-12">
          <div class="font-bold mb-10">Voucher</div>
          <div class="box-mini">
            <div class="p-15 pb-0">
              <div class="row">
                <div class="col-sm-7">
                  <a v-if="getRoleId != '33'" @click="openPage('/vouchers/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
                </div>
                <div class="col-sm-2">
                  <table>
                    <tr>
                      <!-- <td>
                        <a @click="exportBooking()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                      </td> -->
                      <td>
                        <!-- <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates" name="export_date_start" class="font-13"></flat-pickr> -->
                      </td>
                    </tr>
                  </table>
                </div>

                <!-- <div class="col-sm-3"> -->
                  <!-- <div class="row">
                    <div class="col-sm-4 col-form-label text-right">
                      Branch
                    </div>
                    <div class="col-sm-8">
                      <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                          <option :value="null">Please select</option>
                          <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                      </b-form-select>
                    </div>
                  </div> -->
                <!-- </div> -->
                <div class="col-sm-3 text-right">
                  <div class="search-header">
                    <div class="custom-search-container">
                      <div class="input-group custom-search">
                        <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                        <span class="icon-magnifier icon-input-custom"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="mb-0">
            <div class="p-15">
              <!-- {{items}} -->
              <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <!-- <template v-slot:cell(name)="data">
                  {{data.item.first_name}} {{data.item.last_name}}
                </template> -->
                <template v-slot:cell(owner)="data">
                  {{ data.item.sales ? data.item.sales.fullname : '' }}
                </template>
                <template v-slot:cell(is_reward)="data">
                  <template>
                    <b-badge v-if="data.item.is_reward == 1" :variant="'success'" >Yes</b-badge>
                    <b-badge v-if="data.item.is_reward == 0"  :variant="'warning'" >No</b-badge>
                  </template>
                </template>
                <template v-slot:cell(membershipStatus)="data">
                  <b-badge :variant="statusMembership(data.item.membership_status.name)" v-if="data.item.membership_status">{{data.item.membership_status.name}}</b-badge>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button v-if="getRoleId != '33'" size="sm" @click="editVoucher('/vouchers/edit?id=' + data.item.id)" class="btn-table primary mr-1">
                        <i class="far fa-edit"></i> Edit
                    </b-button>
                    <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteVoucher(data.item.id)" class="btn-table danger">
                        <i class="fas fa-times"></i> Delete
                    </b-button>
                </template>
              </b-table>
              <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                  :total-pages="totalPage"
                  @page-changed="pageOneChanged"
                  prev-text="Prev" next-text="Next"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loadingActive == true" class="loading-container">
        <div class="wrap-screen w-100 h-100">
          <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
          <br>
          <div class="title-loading color-white">Please wait...</div>
        </div>
      </div>
    </div>
  </template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'leads',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: false
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false
        },
        {
          key: 'voucher_amount',
          label: 'Voucher Amount',
          formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.voucher_amount).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
          sortable: false
        },
        {
          key: 'is_reward',
          label: 'Is Reward',
          sortable: false
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      branch_id: null,
      dataBranch: [],
      valueMemberData: null,
      getParadigmRole: '',
      getRoleMappingId: Auth.Session.get().paradigm_role_mapping_id,
      getRoleId: Auth.Session.get().paradigm_role,
      dateWeek: '',
      itemSales: [],
      items: [],
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      changeMemberValue: '',
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
    }
  },
  methods: {
    openPage (event) {
      this.$router.push(event)
    },
    editVoucher(event) {
      this.$router.push(event)
    },
    sortingChanged (event) {
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
    },
    deleteVoucher(event) {
        this.$swal('Deleted', 'You successfully deleted this file', 'success')
        console.log(event)
    },
    pageOneChanged(event){
      this.currentPage = event
      this.fetchData()
    },
    // eslint-disable-next-line no-unused-vars
    changeBranch(event) {
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    // export
    exportBooking() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      // '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData
      let url = 'crm/v1/export/member_data/1071806?page=&limit=&sorting=&sorting_type=&keyword=&start_date='+dates[0]
        +'&end_date='+dates[1]
        +' ';

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Member_Data-'+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    changeDateBooking(selectedDates, dateStr, instance) {
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    fetchData() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')

      // branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/voucher' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +
        '&start_date=' + dates[0] +'&end_date=' + dates[1] + '&branch_id=' + this.branch_id).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
    }
  },
  // mounted (){
  //   axios.get('crm/v1/sales/').then(response => {
  //     this.itemSales = response.data.data.rows
  //     // console.log('error', response.data.data.rows)
  //   }).catch(error => {
  //     console.log('error', error)
  //   })
  // },
  created () {
    this.getParadigmRole = Auth.Session.get().paradigm_role
    if(Auth.Session.get().paradigm_role === '7' || Auth.Session.get().paradigm_role === '9') {
      this.valueMemberData = 2
    }
    this.fetchData()
  }
}
</script>
